"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ACList = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.itemClassName, itemClassName = _d === void 0 ? 'px-2 py-1 rounded-md cursor-pointer border hover:bg-gray-100' : _d, _e = _a.selectedItemClassName, selectedItemClassName = _e === void 0 ? 'bg-blue-100 border-blue-500' : _e, displayKey = _a.displayKey, displayFormat = _a.displayFormat, displayRenderer = _a.displayRenderer, valueKey = _a.valueKey, onChange = _a.onChange, value = _a.value, compareKey = _a.compareKey, _f = _a.multiSelect, multiSelect = _f === void 0 ? false : _f, // New prop for multi-select
    _g = _a.showSelectAll, // New prop for multi-select
    showSelectAll = _g === void 0 ? false : _g, // New prop for showing "Select All" checkbox
    _h = _a.selectAllText, // New prop for showing "Select All" checkbox
    selectAllText = _h === void 0 ? 'Select All' : _h;
    // console.log('ACList rendered with items:', items);
    var _j = (0, react_1.useState)(multiSelect ? null : value), selectedItem = _j[0], setSelectedItem = _j[1];
    var _k = (0, react_1.useState)(multiSelect ? (Array.isArray(value) ? value : []) : []), selectedItems = _k[0], setSelectedItems = _k[1];
    // useEffect(() => {
    //   setSelectedItem(value);
    // }, [value]);
    (0, react_1.useEffect)(function () {
        if (multiSelect) {
            setSelectedItems(Array.isArray(value) ? value : []);
        }
        else {
            setSelectedItem(value);
        }
    }, [value, multiSelect]);
    var handleItemClick = function (item) {
        if (multiSelect)
            return;
        var isAlreadySelected = isItemSelected(item);
        if (isAlreadySelected) {
            // Deselect the item
            setSelectedItem(null);
            if (onChange) {
                onChange(null);
            }
        }
        else {
            // Select the item
            setSelectedItem(item);
            if (onChange) {
                onChange(valueKey ? item[valueKey] : item);
            }
        }
    };
    // Multi-select mode handler
    var handleCheckboxChange = function (item, e) {
        e.stopPropagation(); // Prevent bubbling to parent elements
        var checked = e.target.checked;
        var newSelectedItems;
        if (checked) {
            // Add item to selection
            newSelectedItems = __spreadArray(__spreadArray([], selectedItems, true), [valueKey ? item[valueKey] : item], false);
        }
        else {
            // Remove item from selection
            newSelectedItems = selectedItems.filter(function (selectedItem) {
                return compareKey
                    ? selectedItem[compareKey] !== item[compareKey]
                    : selectedItem !== item;
            });
        }
        setSelectedItems(newSelectedItems);
        if (onChange) {
            onChange(newSelectedItems);
        }
    };
    // Handle "Select All" checkbox
    var handleSelectAll = function (e) {
        var checked = e.target.checked;
        if (checked) {
            // Select all items
            var allItems = items.map(function (item) { return (valueKey ? item[valueKey] : item); });
            setSelectedItems(allItems);
            if (onChange) {
                onChange(allItems);
            }
        }
        else {
            // Deselect all items
            setSelectedItems([]);
            if (onChange) {
                onChange([]);
            }
        }
    };
    // const isItemSelected = (item: any) => {
    //   if (!selectedItem) return false;
    //   if (compareKey) {
    //     return (
    //       item[compareKey] ===
    //       (typeof selectedItem === 'object'
    //         ? selectedItem[compareKey]
    //         : selectedItem)
    //     );
    //   }
    //   return item === selectedItem;
    // };
    var isItemSelected = function (item) {
        if (multiSelect) {
            return selectedItems.some(function (selectedItem) {
                if (compareKey) {
                    return (item[compareKey] ===
                        (typeof selectedItem === 'object'
                            ? selectedItem[compareKey]
                            : selectedItem));
                }
                return selectedItem === item;
            });
        }
        else {
            // Existing single-select code
            if (!selectedItem)
                return false;
            if (compareKey) {
                return (item[compareKey] ===
                    (typeof selectedItem === 'object'
                        ? selectedItem[compareKey]
                        : selectedItem));
            }
            return item === selectedItem;
        }
    };
    var renderItemContent = function (item) {
        // If a custom renderer is provided, use it
        if (displayRenderer) {
            return displayRenderer(item);
        }
        // If a display format is provided, replace placeholders with values
        if (displayFormat) {
            return displayFormat.replace(/\${([^}]+)}/g, function (_, key) {
                var value = key
                    .split('.')
                    .reduce(function (obj, k) { return obj && obj[k]; }, item);
                return value !== undefined ? value : '';
            });
        }
        // If a display key is provided, show that property
        if (displayKey) {
            return item[displayKey];
        }
        // Default: show the item as a string
        return String(item);
    };
    var allSelected = items.length > 0 && selectedItems.length === items.length;
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, children: [multiSelect && showSelectAll && items.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "mb-2 flex items-center", children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: allSelected, onChange: handleSelectAll, className: "mr-2 h-4 w-4" }), (0, jsx_runtime_1.jsx)("span", { children: selectAllText })] })), items.map(function (item, index) {
                var isSelected = isItemSelected(item);
                return ((0, jsx_runtime_1.jsxs)("div", { className: "".concat(itemClassName, " ").concat(isSelected ? selectedItemClassName : '', " flex items-center"), 
                    // onClick={() => handleItemClick(item)}
                    onClick: multiSelect
                        ? function (e) {
                            // Create a synthetic change event to pass to handleCheckboxChange
                            var syntheticEvent = {
                                target: { checked: !isSelected },
                                stopPropagation: function () { },
                            };
                            handleCheckboxChange(item, syntheticEvent);
                        }
                        : function () { return handleItemClick(item); }, children: [multiSelect && ((0, jsx_runtime_1.jsx)("input", { type: "checkbox", checked: isSelected, onChange: function (e) { return handleCheckboxChange(item, e); }, onClick: function (e) { return e.stopPropagation(); }, className: "mr-2 h-4 w-4" })), renderItemContent(item)] }, index));
            })] }));
};
exports.ACList = ACList;
exports.default = exports.ACList;
